import React from 'react'
import { useParams } from 'react-router-dom'

import { Project } from 'meta/project/project'
import { Story as StoryType } from 'meta/story/story'

import { useGetStory } from 'client/store/story/hooks/story'
import GalleryWrapper from 'client/components/GalleryWrapper'

// import StoryGallery from 'client/components/StoryGallery'
import { Objects } from 'utils/objects'

type RouteParams = {
  projectName: Project['name']
  storyName: StoryType['name']
}

const Story: React.FC = () => {
  const { projectName, storyName } = useParams<RouteParams>()

  if (Objects.isNil(projectName) || Objects.isNil(storyName)) {
    throw new Error(`Invalid project name "${projectName}" for ${storyName}`)
  }

  const { data } = useGetStory({ projectName, storyName })

  if (Objects.isNil(data)) return null

  return <GalleryWrapper opened={Boolean(data)}>{/*<StoryGallery story={data} />*/}</GalleryWrapper>
}

export default Story
